export type ParseJsonOptions = {
  url: string;
};

function isHtmlResponse(contentType: string, body: string): boolean {
  const trimmed = body.trimStart().toLowerCase();
  return (
    contentType.toLowerCase().includes('text/html') ||
    trimmed.startsWith('<!doctype') ||
    trimmed.startsWith('<html')
  );
}

export async function parseJsonResponse<T = unknown>(
  response: Response,
  { url }: ParseJsonOptions,
): Promise<T> {
  const body = await response.text();
  const contentType = response.headers.get('content-type') || '';

  if (isHtmlResponse(contentType, body)) {
    throw new Error(
      `Expected JSON from ${url}, but received HTML. Check REACT_APP_API_BASE or the web-admin gateway proxy.`,
    );
  }

  if (!body.trim()) {
    return null as T;
  }

  try {
    return JSON.parse(body) as T;
  } catch {
    throw new Error(`Expected JSON from ${url}, but received invalid JSON.`);
  }
}

export function extractApiError(data: unknown, fallback: string): string {
  if (data && typeof data === 'object' && 'detail' in data) {
    const detail = (data as { detail?: unknown }).detail;
    if (typeof detail === 'string' && detail.trim()) return detail;
    if (detail != null) return String(detail);
  }
  if (data && typeof data === 'object' && 'message' in data) {
    const message = (data as { message?: unknown }).message;
    if (typeof message === 'string' && message.trim()) return message;
    if (message != null) return String(message);
  }
  return fallback;
}
